import { useState } from 'react'
import { initials } from '../lib/format'

type Props = {
  src: string | null | undefined
  name: string
  size?: number
  className?: string
}

export function Avatar({ src, name, size = 20, className = '' }: Props) {
  const [failed, setFailed] = useState(false)
  const show = src && !failed

  if (!show) {
    return (
      <div
        className={`avatar tab-avatar-fallback ${className}`}
        style={{ width: size, height: size, fontSize: Math.max(8, Math.round(size * 0.42)) }}
        aria-hidden="true"
      >
        {initials(name)}
      </div>
    )
  }

  return (
    <img
      className={`avatar ${className}`}
      src={src}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  )
}